import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="event-types--availibility"
export default class extends Controller {
  static values = { url: String };
  static targets = ["frame", "select"];

  connect() {
    this.reload({ target: this.selectTarget });
  }

  reload({ target }) {
    this.frameTarget.src = this.urlValue.replace(/:id/, target.value);
  }
}
